import { isCell, isLogical, isOverlap, isRange, isTag } from 'components/atoms/ConditionBuilder/utils';
import {
  AutomaticCondition,
  CategoricalActions,
  ConditionOperator,
  ConditionType,
} from 'interfaces/automaticCondition';
import { OrchestrationDataType } from 'interfaces/calculateFeatures';
import { MappingFilterMetadata } from 'interfaces/postProcessingAction';
import { Study } from 'interfaces/study';
import React, { FunctionComponent } from 'react';
import AttributesTableConditionBuilder from './AttributesTableConditionBuilder';
import LogicConditionBuilder from './LogicalConditionBuilder';
import OverlapConditionBuilder from './OverlapConditionBuilder';
import RangeConditionBuilder from './RangeConditionBuilder';
import TagConditionBuilder from './TagConditionBuilder';

export interface AutomaticConditionBuilderProps<T extends AutomaticCondition = AutomaticCondition> {
  condition: T;
  onConditionChange: (condition: T) => void;
  onRemove: () => void;
  study?: Study;
  orchestrationId?: string;
  editable: boolean;
  shouldShowErrors?: boolean;
  featuresOnly?: boolean; // this is used to make 'experimentResult' the default and only source, thereby hiding the source selection
  conditionOptions?: ConditionType[];
  mappingFiltersMetadata?: MappingFilterMetadata[];
  conditionOperators?: ConditionOperator[];
  logicalConditionRecursivelyNumLevels?: number;
  categoricalActions?: CategoricalActions[];
  orchestrationDataTypes?: OrchestrationDataType[];
}

const AutomaticConditionBuilder: FunctionComponent<React.PropsWithChildren<AutomaticConditionBuilderProps>> = ({
  condition,
  ...props
}) => {
  if (isRange(condition)) {
    return <RangeConditionBuilder {...props} condition={condition} />;
  }
  if (isLogical(condition)) {
    return <LogicConditionBuilder {...props} condition={condition} />;
  }
  if (isTag(condition)) {
    return <TagConditionBuilder {...props} condition={condition} />;
  }
  if (isCell(condition)) {
    return <AttributesTableConditionBuilder {...props} condition={condition} />;
  }
  if (isOverlap(condition)) {
    return <OverlapConditionBuilder {...props} condition={condition} />;
  }
  return <></>;
};

export default AutomaticConditionBuilder;
